module.exports = __webpack_public_path__ + "static/EuclidTriangle-Regular-WebS-48db4dbccf232ce1cd5d80043d943076.woff";